import * as fromDatatype from '../datatype-library/index';

export interface bl_b2b_payment_request_stmt_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    data_level: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.NumericDatatypeInterface;
    validated: boolean;
    processed: boolean;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    company_name: fromDatatype.VarcharDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    branch_name: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_delivery_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_goods_received_note_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_goods_received_note_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_purchase_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_purchase_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_b2b_payment_request_stmt_import_file_helper_RowClass implements bl_b2b_payment_request_stmt_import_file_helper_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    hdr_guid: fromDatatype.GuidDataFieldInterface;
    data_level: fromDatatype.VarcharDatatypeInterface;
    short_error_message: fromDatatype.VarcharDatatypeInterface;
    error_stack_trace: fromDatatype.VarcharDatatypeInterface;
    line_number: fromDatatype.NumericDatatypeInterface;
    validated: boolean;
    processed: boolean;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    entity_code: fromDatatype.VarcharDatatypeInterface;
    entity_name: fromDatatype.VarcharDatatypeInterface;
    doc_reference: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    company_guid: fromDatatype.GuidDataFieldInterface;
    company_code: fromDatatype.VarcharDatatypeInterface;
    company_name: fromDatatype.VarcharDatatypeInterface;
    amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    start_date: fromDatatype.TimestampTzDatatypeInterface;
    end_date: fromDatatype.TimestampTzDatatypeInterface;
    date_txn: fromDatatype.TimestampTzDatatypeInterface;
    branch_guid: fromDatatype.GuidDataFieldInterface;
    branch_code: fromDatatype.VarcharDatatypeInterface;
    branch_name: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_delivery_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_delivery_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_delivery_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_goods_received_note_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_goods_received_note_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_goods_received_note_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_goods_received_note_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    int_purchase_order_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    int_purchase_order_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    int_purchase_order_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    int_purchase_order_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_01: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_02: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_no_03: fromDatatype.VarcharDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_txn_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_created_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_modified_date: fromDatatype.TimestampTzDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_excl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_amount_txn_incl_tax: fromDatatype.NumericDatatypeInterface;
    xtn_einvoice_sales_invoice_doc_hdr_property_json: fromDatatype.JsonDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
